import {app} from "./app";

export default {
    /**
     * 添加数组里的Key
     * @param array
     * @returns {*}
     */
    addArrayKey: (array) => {
        return array.map((item, index) => {
            if (typeof item === 'object') {
                item.key = index + 1;
            }
            return item;
        });
    },

    /**
     * 省份列表
     * @returns {*[]}
     */
    provinceList: () => {
        return [
            {"code": "11", "name": "北京"},
            {"code": "12", "name": "天津"},
            {"code": "13", "name": "河北"},
            {"code": "14", "name": "山西"},
            {"code": "15", "name": "内蒙古"},
            {"code": "21", "name": "辽宁"},
            {"code": "22", "name": "吉林"},
            {"code": "23", "name": "黑龙江"},
            {"code": "31", "name": "上海"},
            {"code": "32", "name": "江苏"},
            {"code": "33", "name": "浙江"},
            {"code": "34", "name": "安徽"},
            {"code": "35", "name": "福建"},
            {"code": "36", "name": "江西"},
            {"code": "37", "name": "山东"},
            {"code": "41", "name": "河南"},
            {"code": "42", "name": "湖北"},
            {"code": "43", "name": "湖南"},
            {"code": "44", "name": "广东"},
            {"code": "45", "name": "广西"},
            {"code": "46", "name": "海南"},
            {"code": "50", "name": "重庆"},
            {"code": "51", "name": "四川"},
            {"code": "52", "name": "贵州"},
            {"code": "53", "name": "云南"},
            {"code": "54", "name": "西藏"},
            {"code": "61", "name": "陕西"},
            {"code": "62", "name": "甘肃"},
            {"code": "63", "name": "青海"},
            {"code": "64", "name": "宁夏"},
            {"code": "65", "name": "新疆"}
        ];
    },


    /**
     * 加载图片
     */
    imageLoad: (ctx, src, width, height) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = app.urlEncode(src);
            if (width) img.width = width;
            if (height) img.height = height;
            img.onload = () => {
                resolve(img);
            }
            img.onerror = () => {
                console.error("头像错误");
                resolve(false);
            }
            img.onabort = () => {
                resolve(false);
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/utils.jsx